module.exports = __webpack_public_path__ + "static/guarantee-9a04da144eb0ec5f94e148f580a85e01.png";